define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var FaxSettingsModel = /** @class */ (function () {
        function FaxSettingsModel(data) {
            this.Id = ko.observable(0);
            this.PhoneNumberId = ko.observable();
            this.Username = ko.observable();
            this.Password = ko.observable();
            this.DisplayName = ko.observable();
            this.DailyOutboundLimit = ko.observable(50);
            this.OutboundEmails = ko.observable();
            this.InboundEmails = ko.observable();
            this.ChangeOutboundEmails = ko.observable(true);
            this.ChangeInboundEmails = ko.observable(true);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, FaxSettingsModel.Mapping, self);
            }
        }
        FaxSettingsModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new FaxSettingsModel(options.data);
            }
        };
        return FaxSettingsModel;
    }());
    return FaxSettingsModel;
});
//# sourceMappingURL=FaxSettingsModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/FaxSettingsModel.js
// module id = 191
// module chunks = 2